<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 md-xlarge-size-70 mx-auto">
      <md-card class="md-card-calendar">
        <md-card-content>
          <fullCalendar
            ref="calendar"
            defaultView="dayGridMonth"
            :height="810"
            :plugins="calendarPlugins"
            :events="events"
            :selectable="true"
            @dateClick="createEvent"
            @eventClick="selectEvent"
            :header="header"
            :buttonIcons="buttonIcons"
            :selectHelper="true"
            :editable="true"
            :showNonCurrentDates="false"
            :datesRender="getDataFromApi"
          />
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-size-100 md-xlarge-size-30 mx-auto">
      <EventFormCard
        v-if="selectedEvent"
        :value="selectedEvent"
        @saved="saved"
        @cancel="unselectEvent"
        @delete="deleteEvent"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import Swal from "sweetalert2";

import BottomDayInformation from "@/components/Calendar/BottomDayInformation.vue";
import EventFormCard from "@/components/Calendar/EventFormCard.vue";
import CalendarApi from "../../../openapi/src/api/CalendarApi";

const calendarApi = new CalendarApi();

export default {
  components: {
    FullCalendar,
    // eslint-disable-next-line vue/no-unused-components
    BottomDayInformation,
    EventFormCard
  },
  data() {
    return {
      calendarPlugins: [dayGridPlugin, interactionPlugin],
      header: {
        right: "prev,next,today"
      },
      buttonIcons: {
        close: "fa-times",
        prev: "left-single-arrow",
        next: "right-single-arrow",
        prevYear: "fa-angle-double-left",
        nextYear: "fa-angle-double-right"
      },
      events: [],
      status: false,
      selectedEvent: null
    };
  },
  methods: {
    getDataFromApi: function(calendar) {
      this.events = [];
      this.status = [];

      var date = this.$refs["calendar"].getApi().getDate();
      calendarApi.getCalendar(
        this.$root.hotelId,
        {
          year: date.getFullYear(),
          month: date.getMonth() + 1
        },
        (error, data) => {
          if (!error) {
            if (data.date_info === null) data.date_info = [];

            // we transform received DTO to Objects expected by our component
            data.date_info.forEach(date => {
              this.status[this.moment(date.key).format("YYYY-MM-DD")] = {
                status: date.value.open_closed_status.toLowerCase(),
                adr: date.value.adr,
                current_online_price: date.value.current_online_price,
                current_offline_price: date.value.current_offline_price,
                occupancy: date.value.occupancy,
                description: date.value.description
              };

              if (date.value.events && date.value.events.length) {
                date.value.events.map(event => {
                  this.events.push({
                    id: event.id,
                    title: event.name,
                    allDay: true,
                    start: date.key,
                    backgroundColor: event.color
                  });
                });
              }
            });

            calendar.view.dayGrid.cellEls.forEach(cell => {
              this.addOccData({
                el: cell
              });
            });
          }
        }
      );
    },
    addOccData: function(day) {
      var date = day.el.getAttribute("data-date");

      if (!date || !this.status[date]) return;

      day.el.setAttribute(
        "class",
        day.el.className + " " + this.status[date].status
      );

      if (this.status[date].description)
        day.el.setAttribute("title", this.status[date].description);

      var DayInformationComponent = Vue.extend(BottomDayInformation);
      var occInfo = new DayInformationComponent({
        propsData: {
          data: this.status[date]
        }
      });
      occInfo.$mount();
      day.el.appendChild(occInfo.$el);
    },
    createEvent: function(info) {
      // on select we show the Sweet Alert modal with an input
      Swal.fire({
        title: "Create an Event",
        html: `<div class="md-field md-theme-default">
          <input type="text" id="md-input" class="md-input" required placeholder="Event's name">
          </div>`,
        showCancelButton: true,
        customClass: {
          confirmButton: 'md-button md-success',
          cancelButton: 'md-button md-danger'
        },
        buttonsStyling: false
      }).then(() => {
        var eventTitle = document.getElementById("md-input").value;
        if (!eventTitle) eventTitle = "New event";

        let calendarApi = this.$refs.calendar.getApi();
        let event = {
          id: 0,
          title: eventTitle,
          start: info.dateStr,
          allDay: true,
          backgroundColor: "#785964" // brand-primary color. Should be taken from sass files :))
        };
        this.selectEvent({ event: event });
      });
    },
    selectEvent: function(event) {
      this.selectedEvent = {
        id: event.event.id,
        name: event.event.title,
        travel_date_from: event.event.start,
        travel_date_to: event.event.start,
        color: event.event.backgroundColor,
        golden_days: []
      };
    },
    saved: function(newEvent) {
      this.getDataFromApi();
      this.$root.$emit("saved");
    },
    unselectEvent: function() {
      this.selectedEvent = null;
    },
    deleteEvent: function() {
      this.unselectEvent();
      this.getDataFromApi();
    }
  }
};
</script>
<style lang="scss">
.fc-bg {
  .fc-day {
    &.partial_closed {
      background: repeating-linear-gradient(
        45deg,
        rgb(247, 231, 209) 10px,
        rgb(252, 246, 238) 10px,
        rgb(242, 215, 180) 20px
      );
    }
    &.closed {
      background: repeating-linear-gradient(#f2d7b4, #f2d7b4);
    }
    position: relative;
    .fc-widget-content-bottom {
      position: absolute;
      text-align: center;
      width: 100%;
      bottom: 0;
      padding: 0 5px;
      font-size: 0.8em;
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
}
</style>
<style lang="scss" scoped>
#fullCalendar {
  max-height: 300px;
}

.md-card-calendar {
  .md-card-content {
    padding: 0 !important;
  }
}
</style>
